var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003_168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8V32C0 36.4187 3.58133 40 8 40H32C36.4187 40 40 36.4187 40 32V8C40 3.58133 36.4187 0 32 0H8C3.58133 0 0 3.58133 0 8ZM32 37.3333H8C5.05467 37.3333 2.66667 34.9453 2.66667 32V8C2.66667 5.05467 5.05467 2.66667 8 2.66667H32C34.9453 2.66667 37.3333 5.05467 37.3333 8V32C37.3333 34.9453 34.9453 37.3333 32 37.3333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1344 20.0013L14.2891 28.576V11.4307L29.1344 20.0013Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003_168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/YT.a1b421b698fc7431b297e542dabcb10c.svg";
export { ForwardRef as ReactComponent };